module.exports = __webpack_public_path__ + "static/media/about-somethingColorful.1667b45f.png";